import { GetDocumentMetadataRequest, ResponseWithHeaders, CpsDocumentMetadata } from '@cs-cms/types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { documentsKeys } from '../../queryKeys/documents';

export function useGetDocumentMetadata(
  dto?: GetDocumentMetadataRequest
): UseQueryResult<ResponseWithHeaders<{ metadata: CpsDocumentMetadata }>, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getDocumentMetadata = () => {
    if (servicesCtx?.documentsService && dto) {
      return servicesCtx.documentsService.getDocumentMetadata(dto);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: documentsKeys.documentMetadata(dto),
    queryFn: getDocumentMetadata,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: !!dto,
    refetchOnMount: 'always'
  });
}
